<template>
  <div class="close_msg">
    2025年春のサービスは終了しました。<br>
    これまでの解析結果は引き続きご覧いただけます。<br>
    たくさんのご利用ありがとうございました！
  </div> 
</template>

<style scoped>
.close_msg {
  max-width:1070px;
  padding:8px 0;
  border:1px solid #f47295;
  border-radius:4px;
  background-color:#fff;
  color:#f47295;
  font-size:14px;
  font-weight:400;
  text-align:center
}
</style>